//import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { lighten, Paper, Typography } from "@mui/material";
import { isString } from "lodash";

const Panel = ({ ...props }) => {
    const { gutterBottom = false, sx, title, children, variant = 'default', ...others } = props;
    const theme = useTheme();

    const backgroundColor = () => {
        if (variant === 'default') return lighten(theme.palette.primary.main, 0.65);
        if (variant === 'level1') return lighten(theme.palette.primary.main, 0.80);;
    }

    return (
        <Paper sx={{ backgroundColor: backgroundColor(), mb: gutterBottom ? 2 : 0, p: 2, borderRadius: 5, boxShadow: 'rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px', ...sx }} {...others}>
            {title && isString(title) && <Typography sx={{ fontWeight: 450, mb: 2 }}>{title}</Typography>}
            {children}
        </Paper>
    )
}

export default Panel;